import { render, staticRenderFns } from "./FlatLockIcon.vue?vue&type=template&id=2e7675d2"
import script from "./FlatLockIcon.vue?vue&type=script&lang=js"
export * from "./FlatLockIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports